const EMOJI_COUNT = 24

export const chatEmojis = Array.from({ length: EMOJI_COUNT }, (_, index) => {
  const id = index + 1
  return {
    id,
    token: `[e${id}]`,
    src: require(`@/assets/images/emoji/emoji${id}.png`)
  }
})

const emojiById = chatEmojis.reduce((map, item) => {
  map[item.id] = item
  return map
}, {})

export function parseChatText(text) {
  const source = String(text || '')
  const parts = []
  const re = /\[e(\d{1,2})\]/g
  let last = 0
  let match = re.exec(source)
  while (match) {
    if (match.index > last) {
      parts.push({ type: 'text', text: source.slice(last, match.index) })
    }
    const emoji = emojiById[Number(match[1])]
    if (emoji) {
      parts.push({ type: 'emoji', id: emoji.id, src: emoji.src })
    } else {
      parts.push({ type: 'text', text: match[0] })
    }
    last = match.index + match[0].length
    match = re.exec(source)
  }
  if (last < source.length) {
    parts.push({ type: 'text', text: source.slice(last) })
  }
  return parts
}
